// extracted by mini-css-extract-plugin
export default {"SectionNavText":"SectionNavText_SectionNavText__iexAR"};